import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SectionContainer = styled.section`
  width: 100%;
`;

export const HeaderButton = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#CCCCCC")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  box-shadow: 2px 2px 4px 0px #ffffff40;
  font-weight: normal;
  width: auto;
  padding: 3px 10px;
  font-size: 24px;
  font-family: lato;
  margin-bottom: 0px;
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  line-height: 30px;
  margin-left: ${(props) => (props?.marginLeft ? props?.marginLeft : "0px")};
  width: ${(props) => (props?.width ? props?.width : "100%")};
  z-index: ${(props) => props?.zIndex};
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: 60px;
`;

export const DocumentListViewContainer = styled.section`
  width: 75%;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  margin-top: 30px;
  margin-left: 30px;
`;

export const Circle = styled.span`
  display: inline-block;
  height: 40px;
  width: 40px;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  background: #ffffff;
  font-size: 24px;
  line-height: 36px;
  font-weight: 700;
  margin-right: 10px;
  color: ${(props) => (props?.color ? props?.color : "#fffff")};
`;
